module.exports = __webpack_public_path__ + "img/car_sendai02.e5da07e0.jpg";